import Dashboard from '../pages/Dashboard/Dashboard'
import CompanyDetails from '../pages/ComapnyDetails/CompanyDetails'
import Mysearch from '../pages/Mysearch/Mysearch'
import Myhistory from '../pages/MyHistory/Myhistory'
import Mykohere from '../pages/MyKohere/Mykohere'
import Mycredits from '../pages/MyCredits/Mycredits'

export const Config = [
    {
        path: "Dashboard",
        Element: Dashboard
    },
    {
        path: "companydetails",
        Element: CompanyDetails
    },
    {
        path: "mysearch",
        Element: Mysearch
    },
    {
        path: "myhistory",
        Element: Myhistory
    },
    {
        path: "mykohere",
        Element: Mykohere
    },
    {
        path: "mycredits",
        Element: Mycredits
    },
]

